import Markdown, { RuleType } from 'markdown-to-jsx'
import { Box, Dialog, IconButton, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'

import MarkdownCustomPreElement from '../common/MarkdownCustomPreElement'
import studentSimbaAiDetailsFile from '../../Docs/SimbaAI/PracticeSessionsStudent.md'
import facultySimbaAiDetailsFile from '../../Docs/SimbaAI/PracticeSessionsFaculty.md'
import { Icons } from '../../utils/utilities'
import { useUserStore } from '../../store/user.store'
import axios from 'axios'


const markdownParserOptions = {
    disableParsingRawHTML: true,
    renderRule: ( next, node ) => {
        if ( node.type === RuleType.codeBlock ) {
            return (
                <MarkdownCustomPreElement
                    key={node.text.slice( 0, 20 )}
                    language={node.lang || 'Text'}
                    content={node.text}
                />
            )
        }
        return next()
    },
    overrides: {
        pre: {
            component: MarkdownCustomPreElement,
            props: {
                className: 'markdown-code-pre'
            }
        }
    }
}


const SimbaDetailsDailog = ( { open, onClose } ) => {

    const [markdownContent, setMarkdownContent] = useState( '' )

    const { theme, layout, border } = useTheme()

    const UserStore = useUserStore()

    const getFileContent = useCallback( async () => {
        if ( UserStore.getUser.user_role === "STUDENT" ) {
            const { data } = await axios.get( studentSimbaAiDetailsFile )
            setMarkdownContent( data )
        } else {
            const { data } = await axios.get( facultySimbaAiDetailsFile )
            setMarkdownContent( data )

        }
    }, [UserStore] )

    useEffect( () => {
        getFileContent()
    }, [getFileContent] )

    return (
        <Dialog open={open}>
            <Box overflow="auto" display="flex" flexDirection="column">
                <Box borderBottom={border[1]} padding="20px" display="flex" justifyContent="space-between" gap="20px" alignItems="center">
                    <Box  >
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Learn about Practice Sessions with Simba AI</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary' >
                            {UserStore.getUser.user_role !== 'STUDENT' ? "Features and utilization stratergy of practice sessions with Simba AI." : "Strategic Learning Benefits of practice sessions with Simba AI"}
                        </Typography>
                    </Box>
                    <IconButton onClick={onClose}>
                        {Icons.default.CloseIcon}
                    </IconButton>            </Box>
                <Box flexGrow={1} overflow="auto" padding={layout.pagePadding} className={`custom-markdown ${theme}`}>
                    <Markdown options={markdownParserOptions}>
                        {markdownContent}
                    </Markdown>
                </Box>
            </Box>
        </Dialog>
    )
}

export default SimbaDetailsDailog
